/* global axios */
// FLOW-06 (SPEC S2, S4, R14, H2; PLAN G16; Task 6.3) — as execuções de produção da conta
// (`PowerflowExecucoesController`): a lista e o detalhe da seção Execuções, o "Executar agora" da seção
// Flows, e o reexecutar e o cancelar do detalhe. A execução vive no PowerTools; o Rails põe a régua e a
// conta, e repassa as respostas como vieram (o contrato entre as trilhas, no TASKS). Usa o axios global.
//
// As recusas chegam no `response.data` do erro do axios: a de leigo (D19) é `{erro: {codigo, mensagem,
// como_resolver, detalhe, campo?}}` (422 do pedido que não roda; 404 do flow ou da execução que não é
// da conta; 409 do cancelar de quem já terminou); 403 `{error: 'powerflow_requires_manager'}` para quem
// não vê a aba; 503 `powertools_inalcancavel` e 504 `powertools_demorou` (com `mensagem`) para o
// PowerTools fora do ar ou lento. Quem chama decide o que dizer.
const BASE = accountId => `/api/v1/accounts/${accountId}/powerflow/execucoes`;
const DA = (accountId, id) => `${BASE(accountId)}/${encodeURIComponent(id)}`;

const body = r => r.data;

// Os filtros que a rota repassa ao PowerTools (`FILTROS` do controller): o flow por entrada (uma versão)
// ou por nome (todas, G24), o estado, quem chamou, o período em ISO 8601, a conversa, a busca pelo id e
// o cursor (`antes`, o `proximo` da página anterior). O resto, e o vazio, não vão.
export const FILTROS = [
  'entrada_id',
  'flow_nome',
  'estado',
  'invocador',
  'de',
  'ate',
  'conversation_id',
  'execucao_id',
  'antes',
];

const preenchido = valor =>
  valor !== null && valor !== undefined && String(valor).trim() !== '';

const soOsFiltros = filtros =>
  Object.fromEntries(
    Object.entries(filtros || {}).filter(
      ([nome, valor]) => FILTROS.includes(nome) && preenchido(valor)
    )
  );

export default {
  // `{execucoes, proximo}`, das mais novas para as mais antigas; `proximo` nulo na última página.
  index(accountId, filtros = {}) {
    return axios
      .get(BASE(accountId), { params: soOsFiltros(filtros) })
      .then(({ data }) => ({
        execucoes: Array.isArray(data?.execucoes) ? data.execucoes : [],
        proximo: data?.proximo ?? null,
      }));
  },

  // O item da lista mais `duravel`, `params` (redigido), `resposta`, `reexecucoes`,
  // `gravava_no_passo_que_falhou` e `passos` (G25).
  show(accountId, id) {
    return axios.get(DA(accountId, id)).then(body);
  },

  // S2: roda um flow publicado sem agente (o `create` da rota). `flow` é o id de uma versão ou o nome; a
  // `versao` fica de fora para rodar a publicada mais nova. A conversa e a chave de idempotência são
  // opcionais: a mesma chave em 24 h devolve a mesma execução. Devolve `{execucao_id, estado}`.
  executar(
    accountId,
    {
      flow,
      versao,
      params,
      conversation_id: conversa,
      chave_de_idempotencia: chave,
    }
  ) {
    const corpo = { flow, params: params || {} };
    if (preenchido(versao)) corpo.versao = versao;
    if (preenchido(conversa)) corpo.conversation_id = conversa;
    if (preenchido(chave)) corpo.chave_de_idempotencia = chave;
    return axios.post(BASE(accountId), corpo).then(body);
  },

  // R14: `forma` em `inicio_original`, `inicio_publicada` ou `passo_que_falhou`. Toda reexecução é uma
  // tentativa nova, com chave nova (H2). Devolve `{execucao_id, estado, gravava_no_passo_que_falhou}`:
  // nas formas do início, a execução nova; na do passo que falhou, a mesma.
  reexecutar(accountId, id, forma) {
    return axios.post(`${DA(accountId, id)}/reexecutar`, { forma }).then(body);
  },

  // A enfileirada ou rodando: o passo em curso termina, e nenhum outro começa. Devolve
  // `{execucao_id, estado}`; 409 quando ela já terminou.
  cancelar(accountId, id) {
    return axios.post(`${DA(accountId, id)}/cancelar`).then(body);
  },
};
